module.exports = __webpack_public_path__ + "static/media/diamond.d60ff755.svg";